export default "__VITE_ASSET__C69c49pL__"